export const pageWidth = 1080;
export const contentWidth = 540;
